import React, { useMemo } from 'react'
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import White from '../white'
import Gallery from '../gallery'
import styled from 'styled-components'

const Container = styled.div`
  margin-top: 150px;
  text-align: center;
  h3 {
    margin-bottom: 100px;
    font-family: Oswald, sans-serif;
    font-size: 90px;
    line-height: 100px;
    text-transform: uppercase;
  }
`

const GalleryEmbed = ({ module }) => {
  const { gallery_year, category } = module;

  const data = useStaticQuery(graphql`
    query {
      allSanityGallery {
        edges {
          node {
            title
            year
            category
            images {
              asset {
                gatsbyImageData(width: 776, placeholder: BLURRED)
                width
                height
              }
            }
          }
        }
      }
    }
  `)

  const photos = useMemo(() => {
    return data.allSanityGallery.edges
      .filter(({ node }) => node.year === gallery_year && node.category === category)
      .flatMap(({ node }) => 
        node.images
          .filter(image => image.asset && image.asset.gatsbyImageData) // Filter out null assets
          .map(image => {
            const gatsbyImageData = getImage(image.asset);
            return gatsbyImageData ? {
              year: node.year,
              category: node.category,
              caption: image.caption,
              attribution: image.attribution,
              src: gatsbyImageData,
              // Use optional chaining to safely access width and height
              width: gatsbyImageData.width ?? 300, // Fallback width if not available
              height: gatsbyImageData.height ?? 200 // Fallback height if not available
            } : null;
          })
      )
      .filter(Boolean); // Remove any null results
  }, [data, gallery_year, category]);


  return (
    <White>
      <Container>
        <h3>Galleries</h3>
        <Gallery photos={photos} />
      </Container>
    </White>
  )
}

export default GalleryEmbed